import React from "react";

import { ConfirmationModal } from "@/components/ui";
import type { FacilitatorStatus } from "@/hooks/useMarketplaceFacilitators";

import { InlineError } from "./InlineError";

interface RemoveFacilitatorModalProps {
  row: FacilitatorStatus | null;
  error?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const count = (n: number, noun: string) => `${n} ${noun}${n === 1 ? "" : "s"}`;

export const RemoveFacilitatorModal: React.FC<RemoveFacilitatorModalProps> = ({
  row,
  error,
  onConfirm,
  onCancel,
}) => (
  <ConfirmationModal
    open={!!row}
    onOpenChange={(open) => !open && onCancel()}
    title={`Remove as ${row?.marketplaceName ?? ""} facilitator?`}
    description={
      row &&
      `This facilitator lists ${count(row.linkedProducts, "product")} and has ${count(row.openOrders, "open order")} for ${count(row.sellers, "facilitated seller")}. Existing products and orders stay with it. New products use another facilitator, if one is marked.`
    }
    confirmLabel="Remove"
    onConfirm={onConfirm}
    onCancel={onCancel}
  >
    {error && (
      <InlineError
        message={error}
        className="mt-3 max-w-none text-sm leading-6"
      />
    )}
  </ConfirmationModal>
);
